export default __webpack_public_path__ + "static/media/trinidad_icon.9e78a573.svg";